import { GetServiceDetailRequest } from "../../Model/Request/MusteriKurumTanim/GetServiceDetailRequest";
import { GetClientsTreeViewResponse } from "../../Model/Response/ClientAgent/GetClientsTreeViewResponse";
import { ApiBaseResponse } from "../../Model/Response/Common/ApiBaseResponse";
import { GetClientsStructureByCityIdResponse } from "../../Model/Response/MusteriKurumTanim/GetClientsStructureByCityIdResponse";
import { GetServiceDetailResponse } from "../../Model/Response/MusteriKurumTanim/GetServiceDetailResponse";
import { GlobalOperations } from "../Common/GlobalOperations";

export async function GetServiceDetail(request: GetServiceDetailRequest): Promise<ApiBaseResponse<GetServiceDetailResponse> | null> {

    let response = await fetch(GlobalOperations.BaseUrl + "api/MusteriKurumTanim/GetServiceDetail",
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(request)
        });

    let data: ApiBaseResponse<GetServiceDetailResponse> = await response.json();
    return data;
}

export async function GetClientsStructureByCityId(ClientId: number, CityId: number): Promise<ApiBaseResponse<GetClientsStructureByCityIdResponse> | null> {
 

    let response = await fetch(GlobalOperations.BaseUrl + "api/MusteriKurumTanim/GetClientsStructureByCityId/" + ClientId + '/' + CityId,
        {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization':  GlobalOperations.UserToken
            }
        });

    let data: ApiBaseResponse<GetClientsStructureByCityIdResponse> = await response.json();
    return data;
}

export async function GetClientsTreeView(CompanyId: number): Promise<ApiBaseResponse<GetClientsTreeViewResponse> | null> {

   

    let response = await fetch(GlobalOperations.BaseUrl + "api/MusteriKurumTanim/GetClientsTreeView/" + CompanyId,
        {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization':  GlobalOperations.UserToken
            }
        });

    let data: ApiBaseResponse<GetClientsTreeViewResponse> = await response.json();
    return data;
}